import axios from 'axios'

const IP_API_BASE_URL = 'https://pro.ip-api.com/json/'
export const IP_API_KEY = process.env.REACT_APP_IP_API_KEY || ''

export const iPapiClient = () => {
  return axios.create({
    baseURL: IP_API_BASE_URL,
  })
}
